<template>
  <edit-user-profile-form
    :profile="profile"
    :state="state"
    :change-password-state="state"
    :submitting="submitting"
    :active-tab="activeTab"
    @submit="onUpdateProfile"
    @change-password="onChangePassword"
  />
</template>

<script>
import EditUserProfileForm from '@/components/forms/EditUserProfileForm.vue'

export default {
  name: 'EditUserProfile',

  props: {
    profile: {
      type: Object,
      required: true
    },

    activeTab: {
      type: Number
    }
  },

  data() {
    return {
      submitting: false,
      state: {}
    }
  },

  methods: {
    onUpdateProfile(data) {
      this.submitting = true
      this.$store.dispatch('updateProfileMe', data)
        .then(() => this.$emit('submitted'))
        .catch(errors => { this.state = errors })
        .finally(() => (this.submitting = false))
    },

    onChangePassword(data) {
      this.submitting = true
      this.$store.dispatch('changePassword', data)
        .then(() => this.$emit('submitted'))
        .catch(errors => { this.state = { ...errors, newPassword: errors.newPassword1 } })
        .finally(() => (this.submitting = false))
    }
  },

  components: {
    EditUserProfileForm
  }
}
</script>
